import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// Configure i18next to load JSON namespaces from /public/locales
i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    ns: [
      'nav',
      'auth',
      'chat',
      'consent',
      'tips',
      'journey',
      'arrow',
      'error',
      'about',
      'pricing',
      'pricing_policy',
      'footer',
      'privacy',
      'terms',
      'security',
      'useCases',
      'documentation',
      'main',
      'settings',
      'features',
      'edu',
      'enterprise',
      'org',
      'gov',
      'testimonials',
      'invest',
      'contact',
      'planDetails',
      'paymentSuccess',
      'seo',
      'questlog'
    ],
    defaultNS: 'nav',

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },

    supportedLngs: ['en', 'zh', 'cn', 'de', 'es', 'pl', 'hi', 'ta', 'te', 'ne', 'he', 'fr', 'ja', 'pt', 'id', 'ru', 'nl'],
  });

export default i18n;
